export default __webpack_public_path__ + "static/media/Brochure_ta.2fa3ee41.pdf";